module.exports = __webpack_public_path__ + "img/small_60 Antracyt piaskowany_satin.2c4b2026.png";